import styled from 'styled-components'

export const Container = styled.div<any>`
  display: flex;
  align-items: ${props => (props.isMobile ? 'flex-start' : 'center')};
  flex-direction: ${props => (props.isMobile ? 'column' : 'row')};
  padding: 7px 42px 22px 33px;
  img {
    width: 67.08px;
    height: 70px;
  }

  svg {
    margin-right: 8px;
    color: ${props => props.theme.tertiary};
    cursor: pointer;
  }
`

export const ProductInfos = styled.div<any>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${props => (props.isMobile ? '100%' : '50%')};

  img {
    margin-right: ${props => (props.isMobile ? 'auto' : '')};
    object-fit: cover;
  }
`

export const ProductName = styled.span<any>`
  margin-left: ${props => (props.isMobile ? '24.92px' : '14.92px')};
  ${({ isMobile }) =>
    !isMobile &&
    `
    padding-right: 92px;
  `}

  font-size: ${props => (props.isMobile ? '1rem' : '1rem')};
`

export const Quantity = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 72px;

  .remove-button:hover {
    color: #115850;
  }

  span {
    font-size: 12px;
  }

  select {
    width: 72px;
    height: 36px;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #115850;
    background-color: #ffffff;
    border: 1.5px solid rgba(17, 88, 80, 0.5);
    border-radius: 8px;
    padding: 0 8px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23115850' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    padding-right: 24px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    outline: none;

    &:hover {
      border-color: #115850;
    }

    &:focus {
      border-color: #115850;
      box-shadow: 0 0 0 3px rgba(17, 88, 80, 0.15);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`

export const ProductPrice = styled.span<any>`
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  text-align: center;

  ${({ isMobile }) =>
    isMobile &&
    `
    display: flex;
    flex-direction: column;
  `}

  span {
    font-family: 'Lato', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: #115850;
  }
`

export const ProductTotal = styled(ProductPrice)``

export const ProductProperties = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-left: ${props => (props.isMobile ? '0px' : '30px')};

  width: ${props => (props.isMobile ? '100%' : '50%')};

  margin-top: ${props => (props.isMobile ? '16px' : '')};
`
